export const ESTADO_CUSTODIA_CAB_CODE = 'CUS-0000-0000';
//detalles de estados
export const ESTADO_CREADO_CODE = 'CUS-0000-0000-000';
export const ESTADO_EN_INICIADO_CODE = 'CUS-0000-0000-001';
export const ESTADO_FINALIZADO_CODE = 'CUS-0000-0000-002';
